// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot-password-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: var(--vb-bg);
  color: var(--vb-text);
  padding: 24px 16px;
  box-sizing: border-box;
}

.forgot-password-content {
  width: 100%;
  max-width: 420px;
}

.forgot-password-box {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  padding: 28px 24px;
  border-radius: var(--vb-radius-lg);
  box-shadow: var(--vb-shadow);
}

.forgot-password-box h1 {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 700;
  color: var(--vb-text-muted);
  text-align: left;
}

.forgot-password-box h2 {
  margin: 0 0 16px;
  font-size: 24px;
  font-weight: 800;
  text-align: left;
}

.forgot-password-box form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.forgot-password-box input {
  padding: 12px 14px;
  border: 1px solid var(--vb-border-strong);
  border-radius: var(--vb-radius-sm);
  font-size: 16px;
  background: var(--vb-surface-2);
  color: var(--vb-text);
}

.forgot-password-box .submit-btn {
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
  border: none;
  padding: 12px;
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  font-size: 16px;
  font-weight: 750;
}

.auth-options {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.back-button {
  background: none;
  border: none;
  color: var(--vb-primary);
  cursor: pointer;
  font-size: 14px;
  font-weight: 650;
}

.success-message {
  color: var(--vb-success);
  background: var(--vb-success-soft);
  padding: 10px 12px;
  border-radius: 10px;
  text-align: center;
  font-weight: 650;
}

.error-message {
  color: var(--vb-danger);
  background: var(--vb-danger-soft);
  padding: 10px 12px;
  border-radius: 10px;
  text-align: center;
  font-weight: 650;
}
`, "",{"version":3,"sources":["webpack://./src/components/ForgotPassword.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,kCAAkC;EAClC,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".forgot-password-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: var(--vb-bg);\n  color: var(--vb-text);\n  padding: 24px 16px;\n  box-sizing: border-box;\n}\n\n.forgot-password-content {\n  width: 100%;\n  max-width: 420px;\n}\n\n.forgot-password-box {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  padding: 28px 24px;\n  border-radius: var(--vb-radius-lg);\n  box-shadow: var(--vb-shadow);\n}\n\n.forgot-password-box h1 {\n  margin: 0 0 4px;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--vb-text-muted);\n  text-align: left;\n}\n\n.forgot-password-box h2 {\n  margin: 0 0 16px;\n  font-size: 24px;\n  font-weight: 800;\n  text-align: left;\n}\n\n.forgot-password-box form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.forgot-password-box input {\n  padding: 12px 14px;\n  border: 1px solid var(--vb-border-strong);\n  border-radius: var(--vb-radius-sm);\n  font-size: 16px;\n  background: var(--vb-surface-2);\n  color: var(--vb-text);\n}\n\n.forgot-password-box .submit-btn {\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n  border: none;\n  padding: 12px;\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 750;\n}\n\n.auth-options {\n  display: flex;\n  justify-content: center;\n  margin-top: 16px;\n}\n\n.back-button {\n  background: none;\n  border: none;\n  color: var(--vb-primary);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 650;\n}\n\n.success-message {\n  color: var(--vb-success);\n  background: var(--vb-success-soft);\n  padding: 10px 12px;\n  border-radius: 10px;\n  text-align: center;\n  font-weight: 650;\n}\n\n.error-message {\n  color: var(--vb-danger);\n  background: var(--vb-danger-soft);\n  padding: 10px 12px;\n  border-radius: 10px;\n  text-align: center;\n  font-weight: 650;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
